// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-animation {
  margin-top: 1rem;
  color: var(--mittelblau);
  font-weight: normal;
}

.feedback {
  margin-top: 1rem;
  margin-bottom: 1.25rem;
}

.feedback.success {
  color: var(--dunkelgruen);
}

.feedback.error {
  color: var(--blutorange);
}

.process-output {
  margin-top: 1rem;
  white-space: pre-wrap;
  color: var(--dunkelgruen);
}

.process-notification {
  margin-top: 1.5rem;
}

.process-header {
  color: var(--dunkelgruen);
  font-weight: normal;
  margin-bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/arbeit/jobszuteilen/JobsZuteilen.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".loading-animation {\n  margin-top: 1rem;\n  color: var(--mittelblau);\n  font-weight: normal;\n}\n\n.feedback {\n  margin-top: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.feedback.success {\n  color: var(--dunkelgruen);\n}\n\n.feedback.error {\n  color: var(--blutorange);\n}\n\n.process-output {\n  margin-top: 1rem;\n  white-space: pre-wrap;\n  color: var(--dunkelgruen);\n}\n\n.process-notification {\n  margin-top: 1.5rem;\n}\n\n.process-header {\n  color: var(--dunkelgruen);\n  font-weight: normal;\n  margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
